import styled from "styled-components";

export const ResCon = styled.main`
  direction: rtl;
  width: 100%;
  display: block;
  margin-top: @media screen and (max-width: 768px) {

  }
`;

export const ResuHe = styled.h3`
  font-size: 1.4rem;

  @media screen and (max-width: 768px) {
  }
`;
export const ResuPara = styled.p`
  font-size: 1.6rem;
  color: #494949;

  @media screen and (max-width: 768px) {
    font-size: 1.4rem;
  }
`;
export const ResHeader = styled.header`
  margin-bottom: -60px;
  background: #f6f6f7;
  padding-top: 10px;

  @media screen and (max-width: 768px) {
    margin-bottom: -40px;
  }
`;
export const ResTop = styled.div`
  padding-bottom: 56px;
  margin-left: 20px;
  margin-right: 20px;

  @media screen and (max-width: 768px) {
    padding-bottom: 49px;
    margin-left: 15px;
    margin-right: 15px;
  }
`;
export const ResHe = styled.h1`
  width: auto;
  margin-top: 0;
  margin-bottom: 10px;
  padding-top: 0;
  color: #343c4b;
  font-size: 1.75rem;
  line-height: 1.15;

  @media screen and (max-width: 768px) {
  }
`;
export const ResPara = styled.p`
  margin-bottom: 0;
  min-width: 100%;
  font-size: 1.125rem;
  line-height: 1.3333;

  @media screen and (max-width: 768px) {
  }
`;
export const CardCon = styled.div`
  margin-bottom: 20px;
  margin-left: 15px;
  margin-right: 15px;

  @media screen and (max-width: 768px) {
  }
`;
export const TraCon = styled.div`
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  flex: 0 0 calc(50% - 10px);
  min-width: 0;
  margin: 0;
  border: 1px solid #dddfe2;
  border-radius: 10px;
  margin-bottom: 10px;
  transition: all 0.2s ease-in-out;
  margin-top: 10px;

  @media screen and (max-width: 768px) {
  }
`;
export const TraSubCon = styled.div`
  height: 100%;

  @media screen and (max-width: 768px) {
  }
`;
export const TraMain = styled.div`
  padding: 15px 20px;
  height: 100%;

  @media screen and (max-width: 768px) {
  }
`;
export const TraInfo = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  font-size: 1rem;
  line-height: 1.5;

  @media screen and (max-width: 768px) {
  }
`;
export const TraHe = styled.h3`
  @media screen and (max-width: 768px) {
  }
`;
export const TraMid = styled.div`
  flex-grow: 1;

  @media screen and (max-width: 768px) {
  }
`;
export const TraOne = styled.div`
  margin: 0 0 15px;

  @media screen and (max-width: 768px) {
  }
`;
export const TraOnCon = styled.div`
  font-size: 1rem;
  line-height: 1.5;

  @media screen and (max-width: 768px) {
  }
`;
export const TraSp1 = styled.span`
  @media screen and (max-width: 768px) {
  }
`;
export const TraSp2 = styled.span`
  font-weight: 600;
  @media screen and (max-width: 768px) {
  }
`;
export const TraSp3 = styled.span`
  color: #4298b4;

  @media screen and (max-width: 768px) {
  }
`;
export const TraSp4 = styled.span`
  margin-left: 4px;
  display: inline-flex;
  align-items: center;
  position: relative;

  @media screen and (max-width: 768px) {
  }
`;
export const TraSp5 = styled.span`
  display: inline-flex;
  @media screen and (max-width: 768px) {
  }
`;
export const TraSp6 = styled.span`
  width: 10px;
  height: 10px;
  @media screen and (max-width: 768px) {
  }
`;
export const TraBut = styled.button`
  display: inline-flex;
  @media screen and (max-width: 768px) {
  }
`;
export const TraTwo = styled.div`
  margin: 0 0 15px;

  @media screen and (max-width: 768px) {
  }
`;
export const TraThr = styled.div`
  margin: 0 0 15px;

  @media screen and (max-width: 768px) {
  }
`;
export const ProCon = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  align-items: flex-end;

  @media screen and (max-width: 768px) {
  }
`;
export const ProTop = styled.div`
  width: 50%;
  font-weight: 600;
  text-transform: none;
  color: #787f8d;
  font-size: 0.9rem;
  line-height: 1.5;

  @media screen and (max-width: 768px) {
  }
`;
export const ProMiddle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  order: -1;
  width: 100%;
  margin: 0;

  @media screen and (max-width: 768px) {
  }
`;
export const ProNo = styled.div`
  right: 41%;
  align-self: flex-end;
  flex-direction: row-reverse;
  margin-right: -16px;
  align-items: center;
  position: relative;
  display: inline-flex;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
  }
`;
export const ProNone = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
  }
`;
export const ProIn = styled.div`
  height: 12px;
  margin: 6px 0;
  border-radius: 8px;
  background-color: #eeeff1;
  position: relative;
  width: 100%;

  @media screen and (max-width: 768px) {
  }
`;
export const ProOn = styled.div`
  margin-right: auto;
  border-radius: 8px;
  background-color: #eeeff1;
  border-radius: 8px;
  position: relative;
  width: 100%;
  height: 100%;

  @media screen and (max-width: 768px) {
  }
`;
export const ProRe = styled.div`
  width: 100%;
  background-color: #4298b4;
  margin-right: auto;
  border-radius: 8px;
  transition: width 0.5s ease;
  height: 100%;

  @media screen and (max-width: 768px) {
  }
`;
export const ProFe = styled.div`
  left: 59%;
  background-color: #4298b4;
  margin-left: -8px;
  top: -2px;
  position: absolute;
  z-index: 1;
  width: 16px;
  transition: left 0.5s ease;
  height: 16px;
  border: 3px solid white;
  border-radius: 100px;
  box-shadow: 0 4px 10px rgba(29, 36, 50, 0.15);
  @media screen and (max-width: 768px) {
  }
`;
export const ProBottm = styled.div`
  text-align: left;
  width: 50%;
  font-weight: 600;
  text-transform: none;
  color: #787f8d;
  font-size: 0.9rem;
  line-height: 1.5;

  @media screen and (max-width: 768px) {
  }
`;
